<template>
<div>
  <common-title :title="'评审论文'"></common-title>
  <detail-paper-component :type="'review'" :id="id"></detail-paper-component>
</div>
</template>

<script>
import commonTitle from "@/components/common/commonTitle";
import detailPaperComponent from "@/components/paper/detailPaperComponent";
export default {
  data(){
    return {

    }
  },
  components:{
    commonTitle,
    detailPaperComponent,
  },
  created(){
    this.id = this.$route.query.id;
  }
}
</script>

<style scoped>

</style>
